export const API_BASE_URL = 'https://dnevnik-rg.ru/api';
export const MAIN_API_PATH = '/main.php';
